import { createLazyComponent } from "@/shared/utils/lazyUtils";

// Layout Components
export const LazyInteractiveSurveyLayout = createLazyComponent(
  () => import("@/shared/components/InteractiveSurveyLayout"),
  { chunkName: "interactive-survey-layout" },
);

export const LazyInteractiveSurveyGroupLayout = createLazyComponent(
  () => import("@/shared/components/InteractiveSurveyGroupLayout"),
  { chunkName: "interactive-survey-group-layout" },
);

export const LazyProtectedRoute = createLazyComponent(
  () => import("@/shared/components/ProtectedRoute"),
  { chunkName: "protected-route" },
);


// Preload functions for critical routes
export const preloadMainAppComponents = () => {
  import("@/shared/components/ProtectedRoute");
};
